/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AutomationFinAIAgentContentController from 'embercom/controllers/apps/app/automation/fin-ai-agent/content';

export default class AutomationFinAIAgentContentRoute extends Route {
  @service declare intl: IntlService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.content',
  };

  get titleToken() {
    return this.intl.t('ai-agent.train.content');
  }

  resetController(controller: AutomationFinAIAgentContentController, isExiting: boolean) {
    if (isExiting) {
      controller.set('openSalesforceSync', undefined);
      controller.set('salesforceSyncStep', undefined);
    }
  }
}
